export const GET_STUDIO_SESSION_MERCURY = "GET_STUDIO_SESSION_MERCURY";
export const GET_PROJECT_MERCURY = "GET_PROJECT_MERCURY";
